import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/brand/brand-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-0bd5387c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-col-11" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons no-items-icon" }, "arrow_back_ios", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "message-content" }
const _hoisted_5 = { class: "button-container" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "button-container" }
const _hoisted_8 = { class: "p-d-flex p-flex-wrap p-justify-between p-mt-4" }
const _hoisted_9 = { class: "campaign-header-name" }
const _hoisted_10 = { class: "p-d-flex" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "Campaign Budget is below 15%"),
  /*#__PURE__*/_createElementVNode("p", { class: "p-left" }, " Make sure to create your content quick to earn from this campaign! But be aware, once the budget is gone, its gone! ")
], -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "p-d-flex p-justify-between block-btn" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "modal-apply"
}
const _hoisted_17 = { class: "p-input-icon-left" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 0,
  class: "channel-item"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 1,
  class: "selected-item"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check check-item" }, null, -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "p-flex-column" }
const _hoisted_26 = { class: "title-channel" }
const _hoisted_27 = { class: "p-d-flex p-flex-column" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 1,
  class: "p-d-flex p-align-center"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 3,
  class: "channel-status p-mr-3 p-ml-2 p-text-bold",
  disabled: true
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "action-block" }
const _hoisted_35 = { class: "selected-items" }
const _hoisted_36 = { key: 4 }
const _hoisted_37 = { class: "p-d-flex p-flex-column" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Warning", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-mt-4 p-mb-6" }, " Are you sure you want to withdraw the application from the campaign? It leads to deleting the submitted content from the campaign and termination of any further payments except sums to be due prior to the moment of withdrawal. ", -1))
const _hoisted_40 = { class: "p-d-flex p-jc-between buttons" }
const _hoisted_41 = { class: "p-d-flex p-flex-column" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Warning", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-mt-4 p-mb-6" }, " Are you sure you want to withdraw the application from the campaign? It leads to deleting the submitted content from the campaign and termination of any further payments except sums to be due prior to the moment of withdrawal. ", -1))
const _hoisted_44 = { class: "p-d-flex p-jc-between buttons" }
const _hoisted_45 = { class: "p-d-flex p-flex-column" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " All CPM videos must be submitted as an unlisted YouTube video to be reviewed. Once they are accepted you will be notified and will be good to post your live YouTube video and submit it here. ", -1))
const _hoisted_48 = { class: "p-d-flex p-jc-between buttons p-mt-6" }
const _hoisted_49 = { class: "p-col-11" }
const _hoisted_50 = { class: "p-d-flex p-mt-6" }
const _hoisted_51 = ["src"]
const _hoisted_52 = {
  key: 1,
  src: _imports_0,
  class: "brand-photo"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Brand", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "brand description", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Message = _resolveComponent("Message")!
  const _component_GenericPrompt = _resolveComponent("GenericPrompt")!
  const _component_TermsModal = _resolveComponent("TermsModal")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_OverlayPanelModal = _resolveComponent("OverlayPanelModal")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_progress_campaign_cpm = _resolveComponent("progress-campaign-cpm")!
  const _component_shortCampaignPage = _resolveComponent("shortCampaignPage")!

  return (_openBlock(), _createElementBlock("section", {
    class: "p-grid p-col-12 all-sec",
    style: _normalizeStyle(`--my-src: url(${$setup.campaign?.photo})`)
  }, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", {
        class: "p-mt-4 back p-col-12",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, [
        _hoisted_2,
        _createTextVNode(" Back ")
      ]),
      ($setup.creator.isCreator())
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentApplicationInfoForCreator.capProposals, (capProposal) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "message-content",
                  key: capProposal.proposedPayoutCap
                }, [
                  (capProposal.clientDecision === 'pending')
                    ? (_openBlock(), _createBlock(_component_Message, {
                        key: 0,
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Your application was accepted and an individual maximum payout for your participation was offered. The amount is: " + _toDisplayString(capProposal.proposedPayoutCap) + " USD. ", 1),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_Button, {
                              class: "resolveCap",
                              onClick: _cache[1] || (_cache[1] = () => 
          $setup.resolveCapProposalWrapperFn('accept', $setup.campaign?.id, $setup.currentApplicationInfoForCreator.applicationId))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Accept ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_Button, {
                              class: "resolveCap",
                              onClick: _cache[2] || (_cache[2] = () => 
          $setup.resolveCapProposalWrapperFn('reject', $setup.campaign?.id, $setup.currentApplicationInfoForCreator.applicationId))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Decline ")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.creator.isAgencyOwner())
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentApplicationInfoForAgency, (currentApplication) => {
              return (_openBlock(), _createElementBlock("div", {
                key: currentApplication.applicationId
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentApplication.capProposals, (capProposal) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "message-content",
                    key: capProposal.proposedPayoutCap
                  }, [
                    (capProposal.clientDecision === 'pending')
                      ? (_openBlock(), _createBlock(_component_Message, {
                          key: 0,
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Your application for the channel " + _toDisplayString(capProposal.channelTitle) + " was accepted and an individual maximum payout for your participation was offered. The amount is: " + _toDisplayString(capProposal.proposedPayoutCap) + " USD. ", 1),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_Button, {
                                class: "resolveCap",
                                onClick: () => {
          $setup.resolveCapProposalWrapperFn('accept', $setup.campaign?.id, currentApplication.applicationId, currentApplication.applicationChannel)}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Accept ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_Button, {
                                class: "resolveCap",
                                onClick: () => 
          $setup.resolveCapProposalWrapperFn('reject', $setup.campaign?.id, currentApplication.applicationId, currentApplication.applicationChannel)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Decline ")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      ($setup.gigapayPrompt)
        ? (_openBlock(), _createBlock(_component_GenericPrompt, {
            key: 2,
            version: "gigapayReminder",
            "submit-function": $setup.unmountPrompt,
            useComponentVersionFn: true
          }, null, 8, ["submit-function"]))
        : _createCommentVNode("", true),
      ($setup.cpmApplicationPrompt)
        ? (_openBlock(), _createBlock(_component_GenericPrompt, {
            key: 3,
            version: "cpmApplicationsWaitApproval",
            "submit-function": $setup.unmountPrompt,
            useComponentVersionFn: true,
            closeBtnLabel: "Dismiss"
          }, null, 8, ["submit-function"]))
        : _createCommentVNode("", true),
      ($setup.showApprovedMessagePrompt)
        ? (_openBlock(), _createBlock(_component_GenericPrompt, {
            key: 4,
            version: $setup.creator.isCreator() ? 'cpmApplicationApprovedCreator' : 'cpmApplicationApprovedAgency',
            "submit-function": $setup.unmountPrompt,
            useComponentVersionFn: true
          }, null, 8, ["version", "submit-function"]))
        : _createCommentVNode("", true),
      ($setup.showRejectedMessagePrompt)
        ? (_openBlock(), _createBlock(_component_GenericPrompt, {
            key: 5,
            version: "cpmApplicationRejectedCreator",
            "submit-function": $setup.unmountPrompt,
            useComponentVersionFn: true
          }, null, 8, ["submit-function"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h1", _hoisted_9, _toDisplayString($setup.campaign?.name), 1),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", {
            class: "p-mr-6 term-and-conditions p-d-flex",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showTerms = true))
          }, "Terms and Conditions"),
          _createVNode(_component_TermsModal, {
            show: $setup.showTerms,
            "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (($setup.showTerms) = $event)),
            onCloseModal: _cache[5] || (_cache[5] = ($event: any) => ($setup.showTerms = false)),
            onAcceptTerms: _cache[6] || (_cache[6] = ($event: any) => ($setup.termsAgreed = true))
          }, null, 8, ["show"]),
          _createElementVNode("div", {
            class: _normalizeClass(["p-mr-3 star", [$setup.isCampaignFav ? 'favorite' : 'not-favorite']]),
            onClick: _cache[7] || (_cache[7] = ($event: any) => {
              $setup.toggleCampaignFavorite();
              $setup.isCampaignFav = !$setup.isCampaignFav;
            })
          }, null, 2),
          ($setup.creator.isCreator() && !$setup.isUserAppliedToCampaign && $setup.campaign?.status !== 'completed')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                disabled: $setup.disableApplyButton,
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showTerms = true)),
                style: _normalizeStyle($setup.isUserAppliedToCampaign || $setup.disableApplyButton ? 'background: #5d0106;' : ''),
                class: "apply"
              }, _toDisplayString($setup.getApplyButtonLabel()), 13, _hoisted_11))
            : _createCommentVNode("", true),
          _createVNode(_component_Dialog, {
            header: " ",
            class: "update-profile-basics",
            visible: $setup.showModalBudgetLeft,
            modal: true,
            dismissableMask: true,
            "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ($setup.showModalBudgetLeft = !$setup.showModalBudgetLeft))
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_Button, {
                label: "OK",
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.showModalBudgetLeft = !$setup.showModalBudgetLeft)),
                class: "p-button-text"
              })
            ]),
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_OverlayPanelModal, {
            show: $setup.showModal,
            "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => (($setup.showModal) = $event))
          }, null, 8, ["show"]),
          ($setup.creator.isAgencyOwner() && $setup.campaign?.status !== 'completed')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                disabled: $setup.disableApplyButton || ($setup.isUserAppliedToCampaign && !$setup.creator?.isAgencyOwner()),
                class: "apply",
                style: _normalizeStyle($setup.disableApplyButton ? 'background: #5d0106;' : ''),
                icon: "pi pi-check",
                iconPos: "right"
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", {
                    class: "w-100",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.openAcceptWindow = !$setup.openAcceptWindow)),
                    disabled: $setup.disableApplyButton || $setup.isUserAppliedToCampaign
                  }, _toDisplayString($setup.isCampaignCPM ? "Apply" : "Accept"), 9, _hoisted_15),
                  ($setup.openAcceptWindow)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("h6", null, _toDisplayString($setup.isCampaignCPM ? "Apply as:" : "Accept as:"), 1),
                        _createElementVNode("span", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_InputText, {
                            type: "text",
                            modelValue: $setup.searchInfluencers,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.searchInfluencers) = $event)),
                            onInput: $setup.searchInfluencersUser,
                            class: "search-bar",
                            placeholder: "Search for influencer"
                          }, null, 8, ["modelValue", "onInput"])
                        ]),
                        ($setup.agencyWorkers)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.agencyWorkers, (channel, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "channels-list",
                                key: `${index}_chan`,
                                onClick: ($event: any) => (!$setup.getIndividualChannelInfo(channel?.channel?.channelId, $setup.campaign, 'applicationId') ? 
                    $setup.selectChannel(channel) : null)
                              }, [
                                _createVNode(_component_Divider),
                                (channel?.isChannel)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                      (!$setup.isSelectedChannel(channel) || 
                        $setup.getIndividualChannelInfo(channel?.channel?.channelId, $setup.campaign, 'applicationId'))
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: channel?.channel?.photo,
                                            class: "image-channel"
                                          }, null, 8, _hoisted_21))
                                        : _createCommentVNode("", true),
                                      ($setup.isSelectedChannel(channel) &&
                       !$setup.getIndividualChannelInfo(channel?.channel?.channelId, $setup.campaign, 'applicationId'))
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                                        : _createCommentVNode("", true),
                                      ($setup.isCampaignCPM && $setup.findProgressChannel(channel?.channel?.channelId)?.videoDraft)
                                        ? (_openBlock(), _createBlock(_component_Button, {
                                            key: 2,
                                            icon: "pi pi-bell",
                                            class: "p-button-rounded p-button-outlined red-button",
                                            style: {"color":"red"},
                                            onClick: _withModifiers(($event: any) => {
                          $setup.openProgressChannel = true;
                          $setup.dataProgressChannel = $setup.findProgressChannel(channel?.channel?.channelId);
                        }, ["stop"])
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true),
                                      ($setup.isCampaignCPM && $setup.openProgressChannel && $setup.displayModeratedContent())
                                        ? (_openBlock(), _createBlock(_component_progress_campaign_cpm, {
                                            key: 3,
                                            "open-modal": $setup.openProgressChannel,
                                            onClose: _cache[14] || (_cache[14] = ($event: any) => ($setup.openProgressChannel = false)),
                                            "progress-data": $setup.dataProgressChannel
                                          }, null, 8, ["open-modal", "progress-data"]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_25, [
                                        _createElementVNode("span", _hoisted_26, _toDisplayString(channel?.channel?.title), 1),
                                        _createElementVNode("div", _hoisted_27, [
                                          ($setup.campaign?.status !== 'completed' && !$setup.isCampaignCPM &&
                             $setup.getIndividualChannelInfo(channel?.channel?.channelId, $setup.campaign, 'applicationId'))
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "apply p-mr-3 p-ml-2 p-text-bold",
                                                onClick: ($event: any) => (
                              _ctx.$router.push({
                                name: 'submission-item',
                                params: {
                                  id: $setup.getIndividualChannelInfo(channel?.channel?.channelId, $setup.campaign, 'applicationId'),
                                  campaignID: _ctx.$route.params.campaignID,
                                },
                                query: { channel: channel?.channel?.channelId },
                              })
                            )
                                              }, " SUBMIT CONTENT ", 8, _hoisted_28))
                                            : _createCommentVNode("", true),
                                          ($setup.campaign?.status !== 'completed' 
                            && $setup.isCampaignCPM && $setup.getIndividualChannelInfo(channel?.channel?.channelId, $setup.campaign, 'applicationId') && 
                            !$setup.displayChannelApplicationStatusCondition(channel?.channel?.channelId, $setup.currentApplicationInfoForAgency))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                (!$setup.findProgressChannel(channel?.channel?.channelId)?.draftAccepted)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      class: "apply p-mr-3 p-ml-2 p-text-bold",
                                                      onClick: ($event: any) => {
                                $setup.openCpmPendingModal = true;
                                $setup.selectedChannelForSendPendingVideo = channel?.channel?.channelId;
                              }
                                                    }, " SUBMIT CONTENT CPM ", 8, _hoisted_30))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (
                              $setup.campaign?.status !== 'completed' &&
                              $setup.isCampaignCPM &&
                              $setup.getIndividualChannelInfo(channel?.channel?.channelId, $setup.campaign, 'applicationId') &&
                              $setup.findProgressChannel(channel?.channel?.channelId)?.draftAccepted
                            )
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                class: "apply p-mr-3 p-ml-2 p-text-bold",
                                                onClick: ($event: any) => (
                              _ctx.$router.push({
                                name: 'submission-item',
                                params: {
                                  id: $setup.getIndividualChannelInfo(channel?.channel?.channelId, $setup.campaign, 'applicationId'),
                                  campaignID: _ctx.$route.params.campaignID,
                                },
                                query: { channel: channel?.channel?.channelId },
                              })
                            )
                                              }, " SUBMIT CONTENT ", 8, _hoisted_31))
                                            : _createCommentVNode("", true),
                                          ($setup.campaign?.status !== 'completed' && $setup.isCampaignCPM 
                            && $setup.displayChannelApplicationStatusCondition(channel?.channel?.channelId, $setup.currentApplicationInfoForAgency))
                                            ? (_openBlock(), _createElementBlock("button", _hoisted_32, _toDisplayString($setup.getIndividualChannelApplicationDisplay(channel?.channel?.channelId, $setup.currentApplicationInfoForAgency)), 1))
                                            : _createCommentVNode("", true),
                                          ($setup.getIndividualChannelInfo(channel?.channel?.channelId, $setup.campaign, 'applicationId'))
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 4,
                                                onClick: ($event: any) => {
                              $setup.showWarningWithdrawChannel = true;
                              $setup.withdrawChannelData = channel;
                            },
                                                class: "withdraw"
                                              }, " Leave Campaign ", 8, _hoisted_33))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_19))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, _toDisplayString($setup.selectedChannels?.length) + " selected", 1),
                          ($setup.selectedChannels?.length !== $setup.creator?.agencyWorkers?.length)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "select-all",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.selectAllItems($setup.creator?.agencyWorkers)))
                              }, "Select all"))
                            : _createCommentVNode("", true),
                          ($setup.selectedChannels.length)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: "select-all",
                                onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.selectedChannels = []))
                              }, "Unselect all"))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_Button, {
                          class: "accept-channels",
                          onClick: $setup.acceptChannels,
                          disabled: $setup.loadingAccept
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.isCampaignCPM ? "Apply" : "Accept"), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick", "disabled"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "button-down",
                    onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.openAcceptWindow = !$setup.openAcceptWindow))
                  }, [
                    _createVNode(_component_Button, {
                      class: "button-down-caret",
                      icon: "pi pi-caret-down"
                    })
                  ])
                ])
              ], 12, _hoisted_13))
            : _createCommentVNode("", true),
          ($setup.isUserAppliedToCampaign && $setup.campaign?.status !== 'completed' 
          && $setup.creator.isCreator() && !$setup.isCampaignCPM)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                ($setup.currentUserId)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "apply p-mr-3 p-ml-2 p-text-bold",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (
                _ctx.$router.push({
                  name: 'submission-item',
                  params: {
                    id: $setup.currentUserId,
                    campaignID: _ctx.$route.params.campaignID,
                  },
                })
              ))
                    }, " SUBMIT CONTENT "))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "withdraw",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => {
                $setup.showWarningWithdraw = true;
                $setup.socketMethods.deleteNotification({
                  from: $setup.userId,
                  to: $setup.campaign?.brand?.creator, // for brand
                  type: 'apply',
                  campaignId: $setup.campaign?.id,
                  brandId: $setup.campaign?.brand?.id,
                });
              })
                }, " Leave Campaign ")
              ], 64))
            : _createCommentVNode("", true),
          ($setup.campaign?.status !== 'completed' && $setup.creator.isCreator()
           && $setup.isUserAppliedToCampaign && $setup.isCampaignCPM)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [], 64))
            : _createCommentVNode("", true),
          ($setup.displayModeratedContent())
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                (
                $setup.isCampaignCPM &&
                $setup.currentUserId &&
                ((!$setup.progressCpmCampaign.videoDraft && $setup.isUserAppliedToCampaign) || $setup.progressCpmCampaign?.draftRejected) &&
                !$setup.progressCpmCampaign?.draftAccepted &&
                $setup.creator?.isCreator() && $setup.currentApplicationInfoForCreator.capProposals[0]?.clientDecision === 'approved'
              )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "apply p-mr-3 p-ml-2 p-text-bold",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => ($setup.openCpmPendingModal = true))
                    }, " SUBMIT CONTENT CPM "))
                  : _createCommentVNode("", true),
                ($setup.isCampaignCPM && $setup.progressCpmCampaign.draftAccepted && $setup.currentUserId)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "apply p-mr-3 p-ml-2 p-text-bold",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (
                _ctx.$router.push({
                  name: 'submission-item',
                  params: {
                    id: $setup.currentUserId,
                    campaignID: _ctx.$route.params.campaignID,
                  },
                  query: {
                    draftAccepted: $setup.progressCpmCampaign?.draftAccepted || _ctx.progressCpmCampaignChannels?.draftAccepted,
                  },
                })
              ))
                    }, " SUBMIT CONTENT "))
                  : _createCommentVNode("", true),
                ($setup.isUserAppliedToCampaign && $setup.isCampaignCPM && $setup.creator?.isCreator())
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: "withdraw",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => {
                $setup.showWarningWithdraw = true;
                $setup.socketMethods.deleteNotification({
                  from: $setup.userId,
                  to: $setup.campaign?.brand?.creator, // for brand
                  type: 'apply',
                  campaignId: $setup.campaign?.id,
                  brandId: $setup.campaign?.brand?.id,
                });
              })
                    }, " Leave Campaign CPM "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_Dialog, {
            visible: $setup.showWarningWithdraw,
            class: "p-col-12 p-md-6 p-xl-4 gi-dialog dialog-width",
            modal: true,
            "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('update:show', false)))
          }, {
            header: _withCtx(() => [
              _createElementVNode("section", _hoisted_37, [
                _hoisted_38,
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_Button, {
                    onClick: _cache[23] || (_cache[23] = ($event: any) => ($setup.showWarningWithdraw = false)),
                    class: "p-button-text p-text-bold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("CANCEL")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Button, {
                    class: "red-button",
                    onClick: _cache[24] || (_cache[24] = ($event: any) => ($setup.withdrawCampaign()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("OK")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_Dialog, {
            visible: $setup.showWarningWithdrawChannel,
            class: "p-col-12 p-md-6 p-xl-4 gi-dialog dialog-width",
            modal: true,
            "onUpdate:visible": _cache[28] || (_cache[28] = ($event: any) => (_ctx.$emit('update:show', false)))
          }, {
            header: _withCtx(() => [
              _createElementVNode("section", _hoisted_41, [
                _hoisted_42,
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createVNode(_component_Button, {
                    onClick: _cache[26] || (_cache[26] = ($event: any) => ($setup.showWarningWithdrawChannel = false)),
                    class: "p-button-text p-text-bold"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("CANCEL")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Button, {
                    class: "red-button",
                    onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.withdrawChannelApplication($setup.campaign)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("OK")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"])
        ])
      ]),
      _createVNode(_component_Dialog, {
        visible: $setup.openCpmPendingModal,
        class: "p-col-12 p-md-6 p-xl-4 gi-dialog dialog-width",
        modal: true,
        closable: false,
        "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => (_ctx.$emit('update:show', false)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("section", _hoisted_45, [
            _createElementVNode("div", {
              class: "p-d-flex p-justify-end p-mb-2 full-width pointer",
              onClick: _cache[29] || (_cache[29] = ($event: any) => ($setup.openCpmPendingModal = !$setup.openCpmPendingModal))
            }, "X"),
            ($setup.progressCpmCampaign?.rejectReason)
              ? (_openBlock(), _createElementBlock("p", _hoisted_46, " You last video rejected with reason: " + _toDisplayString($setup.progressCpmCampaign?.rejectReason), 1))
              : _createCommentVNode("", true),
            _hoisted_47,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: $setup.unlistedYouTubeLink,
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (($setup.unlistedYouTubeLink) = $event)),
              placeholder: "Paste YouTube link"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_Button, {
                onClick: $setup.submitUnlistedVideo,
                class: "red-button"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("OK")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      ($setup.isCampaignCPM 
      && $setup.isUserAppliedToCampaign && $setup.displayModeratedContent() && !$setup.creator.isAgencyOwner())
        ? (_openBlock(), _createBlock(_component_progress_campaign_cpm, {
            key: 6,
            "progress-data": $setup.progressCpmCampaign
          }, null, 8, ["progress-data"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_shortCampaignPage, {
      campaignInfo: $setup.campaign,
      "short-preview": false,
      applications: $setup.creator.isAgencyOwner() ? $setup.currentApplicationInfoForAgency : $setup.currentApplicationInfoForCreator,
      hideInfo: { applicationStatus: $setup.applicationStatus, isCampaignCPM: $setup.isCampaignCPM }
    }, null, 8, ["campaignInfo", "applications", "hideInfo"]),
    _createElementVNode("section", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        ($setup.campaign?.brand?.photo.length)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: $setup.campaign?.brand?.photo,
              class: "brand-photo"
            }, null, 8, _hoisted_51))
          : (_openBlock(), _createElementBlock("img", _hoisted_52)),
        _createElementVNode("div", null, [
          _createElementVNode("h3", null, _toDisplayString($setup.campaign?.brand?.name), 1),
          _hoisted_53
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_54,
        _createElementVNode("p", null, _toDisplayString($setup.campaign?.brand?.description), 1)
      ])
    ])
  ], 4))
}